import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import SeaWayBillMobile from '../../SeaWayBillMobile'
import { setUIForwardAction } from '../../../actions'
import { AppState } from '../../../reducers'
import { UI } from '../../../constants/ui'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import pdfIcon from '../../../assets/pdf-icon.png'
import './downloadSWB.less'

const mapDispatchToProps = {
  setUIForward: setUIForwardAction,
}
const mapStateToProps = (state: AppState) => ({
  reservation: state.reservation.reservation,
  terminal: state.terminal.terminal,
})

type DispatchProps = typeof mapDispatchToProps
type StateProps = ReturnType<typeof mapStateToProps>
type Props = DispatchProps & StateProps

const DownloadSWB: React.FC<Props> = ({ setUIForward, reservation, terminal }: Props) => {
  const { t } = useTranslation()
  const seaWayBillRef = useRef<any>(null)
  const [isActivePrintButton, toggleActivityOfPrintButton] = useState(true)

  const onClickDownloadPDF = async () => {
    toggleActivityOfPrintButton(false)
    await createPdf()
    toggleActivityOfPrintButton(true)
  }

  const createPdf = () => {
    return new Promise((resolve: any) => {
      const template = seaWayBillRef.current
      html2canvas(template).then(canvas => {
        const canvasWidth = canvas.width
        const canvasHeight = canvas.height
        const horizontalPadding = 40
        const verticalPadding = 40

        const doc = new jsPDF({
          unit: 'px',
          format: [canvasWidth + horizontalPadding, canvasHeight + verticalPadding],
        })

        doc.setProperties({
          title: 'Seaway Bill',
          author: 'Tallink SILJA CARGO',
        })

        doc.addImage({
          imageData: canvas,
          x: horizontalPadding / 2,
          y: verticalPadding / 2,
          width: canvasWidth,
          height: canvasHeight,
          compression: "FAST",
          format: "PNG"
        })

        const fileName = `seawaybill-${(reservation && reservation.resId) || ''}.pdf`
        doc.save(fileName)
        resolve()
      })
    })
  }

  if (!reservation) {
    return null
  }
  return (
    <div className="downloadSWB">
      <div className="downloadSWB-title" dangerouslySetInnerHTML={{ __html: t('checkinDone') }}></div>
      <div className="button-container">
        <button className="main-button-mobile next" onClick={onClickDownloadPDF} disabled={!isActivePrintButton}>
          <div className="button-content">
            <img className="button-pdf-icon" src={pdfIcon} alt="pdf icon"/>
            {t('downloadPDF')}
          </div>
        </button>
      </div>
      <div className="text" dangerouslySetInnerHTML={{ __html: t('recommendationToDownloadTicket') }}></div>
      <div className="sea-way-template">
        <div ref={seaWayBillRef} className="swb-wrapper">
          <SeaWayBillMobile reservation={reservation} terminal={terminal} />
        </div>
      </div>
      <div className="text" dangerouslySetInnerHTML={{ __html: t('seawayBillMobileBottomInfo') }}></div>
      <div className="button-container">
        <button className="main-button-mobile next" onClick={() => setUIForward(UI.MAIN)}>
          {t('exit')}
        </button>
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(DownloadSWB)
